module.exports = __webpack_public_path__ + "img/features_hero.10688ce8.jpg";